<a [routerLink]="['/consultations']" routerLinkActive="active">
  <span class="text">{{ 'Мої консультації' | translate }}</span>
</a>
